<template>
  <div>
    <el-dialog
      ref="addEditViewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="abow_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @open="handleOpen('addEditViewDialog')"
    >
      <div
        v-loading="loading"
        :loading="loading"
        :element-loading-text="loadingText"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-form
          ref="dialogAddEditForm"
          :model="dialogAddEditForm"
          :rules="dialogAddEditFormRules"
          class="add-edit-view-form"
          @submit.native.prevent
        >
          <div class="modal-box">
            <h3 class="modal-title">
              基础信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item
                    label="出库仓库"
                    prop="depotId"
                  >
                    <el-select
                      v-model="dialogAddEditForm.depotId"
                      filterable
                      clearable
                      placeholder="请选择出库仓库"
                      style="width:100%"
                      @change="depotChangeFun"
                    >
                      <el-option
                        v-for="item in depotOptions"
                        :key="item.data"
                        :label="item.label"
                        :value="item.data"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label="出库类型"
                    prop="outdepotType"
                  >
                    <el-select
                      v-model="dialogAddEditForm.outdepotType"
                      filterable
                      clearable
                      placeholder="请选择出库类型"
                      style="width:100%"
                      @change="changeTypeFun"
                    >
                      <el-option
                        v-for="item in typeOptions"
                        :key="item.data"
                        :label="item.label"
                        :value="item.data"
                        :disabled="(item.data === 21 && isFixedAssetDepot === 2) || (item.data !== 21 && isFixedAssetDepot === 1)"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col
                  v-if="dialogAddEditForm.outdepotType === 13"
                  :span="6"
                >
                  <el-form-item
                    label="调入仓库"
                    prop="transferDepotId"
                  >
                    <el-select
                      v-model="dialogAddEditForm.transferDepotId"
                      filterable
                      clearable
                      placeholder="请选择调入仓库"
                      style="width:100%"
                      @change="transferDepotChangeFun"
                    >
                      <el-option
                        v-for="item in depotOptions"
                        :key="item.data"
                        :label="item.label"
                        :value="item.data"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row
                v-if="dialogAddEditForm.outdepotType !== 2 && dialogAddEditForm.outdepotType !== 21 && dialogAddEditForm.outdepotType !== 13"
                :gutter="10"
              >
                <el-col :span="24">
                  <el-form-item
                    label="物料方案"
                    prop="schemeId"
                  >
                    <el-select
                      v-model="dialogAddEditForm.schemeId"
                      filterable
                      clearable
                      placeholder="请选择物料方案"
                      style="width:100%"
                      @change="changeSchemeFun()"
                    >
                      <el-option
                        v-for="item in schemeOptions"
                        :key="item.data"
                        :label="item.label"
                        :value="item.data"
                      >
                        <span style="float: left">{{ item.label }}</span>
                        <span style="float: right; color: #8492a6; font-size: 13px">{{ item.schemeNo }} ({{ item.schemeType }})</span>
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item
                    label="出库时间"
                    prop="outdepotDate"
                  >
                    <el-date-picker
                      v-model="dialogAddEditForm.outdepotDate"
                      type="date"
                      style="width: 100%;"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="经办人"
                    prop="operater"
                  >
                    <el-input
                      v-model="dialogAddEditForm.operater"
                      placeholder="请输入经办人"
                    />
                  </el-form-item>
                </el-col>
                <el-col
                  v-if="dialogAddEditForm.outdepotType !== 13"
                  :span="6"
                >
                  <el-form-item
                    v-if="dialogAddEditForm.outdepotType === 1 || dialogAddEditForm.outdepotType === 3 || dialogAddEditForm.outdepotType === 4 || dialogAddEditForm.outdepotType === 21"
                    label="物料使用人"
                    prop="receiverId"
                  >
                    <el-select
                      v-model="dialogAddEditForm.receiverId"
                      filterable
                      clearable
                      placeholder="请选择物料使用人"
                      style="width:100%"
                      @change="userChangeFun"
                    >
                      <el-option
                        v-for="item in userOptions"
                        :key="item.data"
                        :label="item.label"
                        :value="item.data"
                      />
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    v-else
                    label="物料使用人"
                    prop="receiver"
                  >
                    <el-input
                      v-model="dialogAddEditForm.receiver"
                      placeholder="请输入物料使用人"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="modal-box">
            <h3 class="modal-title">
              物料信息
              <el-button
                type="success"
                size="mini"
                icon="el-icon-circle-plus-outline"
                style="float:right; margin-top:0.1em; margin-right:15px;"
                @click="handleAdd"
              >
                选择物料
              </el-button>
            </h3>
            <div class="modal-row-box">
              <el-row
                :gutter="10"
                style="margin-bottom:10px;"
              >
                <el-col :span="24">
                  <el-table
                    :data="materialListData"
                    style="width: 100%"
                    :header-cell-style="{background:'#0076ff'}"
                    border
                  >
                    <el-table-column
                      type="index"
                      label="序号"
                      align="center"
                      width="60"
                    />
                    <el-table-column
                      prop="schemeName"
                      label="方案名称"
                      header-align="center"
                      show-overflow-tooltip
                    />
                    <el-table-column
                      prop="materialsName"
                      label="物料名称"
                      width="200"
                      header-align="center"
                      show-overflow-tooltip
                    />
                    <el-table-column
                      prop="sourceTypeStr"
                      label="物料来源"
                      align="center"
                      width="100"
                    />
                    <el-table-column
                      prop="unitName"
                      label="单位"
                      align="center"
                      width="80"
                    />
                    <el-table-column
                      label="数量"
                      align="center"
                      width="100"
                    >
                      <template slot-scope="scope">
                        <el-input
                          v-model="scope.row.amount"
                          @input="(val)=>{computedMathRow(val, scope.row, 'amount')}"
                          @blur="setNumberValueDefaultZero($event, scope.row, 'amount', 4)"
                        />
                      </template>
                    </el-table-column>
                    <!-- <el-table-column
                      label="合计"
                      align="center"
                      width="80"
                    >
                      <template slot-scope="scope">
                        {{ scope.row.total }}
                      </template>
                    </el-table-column> -->
                    <el-table-column
                      label="操作"
                      align="center"
                      width="60"
                    >
                      <template slot-scope="scope">
                        <i
                          class="el-icon-delete"
                          style="color: red; font-size: 16px;"
                          @click="handleDeleteItem(scope.$index)"
                        />
                      </template>
                    </el-table-column>
                  </el-table>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="modal-box pic-container">
            <h3 class="modal-title">
              照片信息<span style="padding-left:30px;color:red">上传图片大小：小于5M; 格式：png、jpg、jpeg、gif</span>
            </h3>
            <div class="modal-row-box">
              <el-upload
                ref="picUpload"
                list-type="picture-card"
                :action="picUploadAction"
                :data="picData"
                :before-upload="beforeAvatarUpload"
                :file-list="initFileList"
                :on-preview="handlePictureCardPreview"
                :headers="{'X-Token': getToken()}"
                multiple
                accept=".jpg,.jpeg,.png,.gif,.JPG,.JPEG,.PNG,.GIF"
                :with-credentials="true"
                :on-success="function (res, file, fileList) {return handleSuccess (res, file, fileList, picList)}"
                :on-remove="(file,fileList)=>handlePictureCardRemove(file,fileList,picList)"
              >
                <el-button
                  type="success"
                  class="upload-button"
                  size="mini"
                  style="margin: top 0.1em; margin-right:15px;"
                  icon="el-icon-folder-opened"
                >
                  选择图片
                </el-button>
              </el-upload>
            </div>
          </div>
          <div class="modal-box">
            <h3 class="modal-title">
              备注信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-form-item prop="remark">
                    <el-input
                      v-model="dialogAddEditForm.remark"
                      type="textarea"
                      placeholder="备注"
                      style="margin-top:10px;"
                      :disabled="eventType==='view'"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          v-if="eventType!=='view'"
          type="primary"
          :disabled="operateButtonDisable"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>

      <el-dialog
        :visible.sync="dialogImageVisible"
        append-to-body
      >
        <img
          width="100%"
          :src="dialogImageUrl"
          alt=""
        >
      </el-dialog>
    </el-dialog>

    <!-- 物料列表 -->
    <material-list-dialog
      :depot-id="dialogAddEditForm.depotId || 0"
      :scheme-id="dialogAddEditForm.schemeId || 0"
      :dialog-visible.sync="dialogMaterialVisible"
      dialog-title="物料信息"
      @selectedMaterialsFun="selectedMaterialsFun"
    />
  </div>
</template>
<script>
// 数据请求
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 设置input值为数字
import setNumberMixin from '@/mixin/setNumberMixin'
// 选择物料
import MaterialListDialog from './materialListDialog'
// 数据请求
import { getToken } from "@/utils/auth"
import { initOutdepotBillApi, initOutdepotBillDetailApi, saveOrUpdateOutdepotBillApi } from '@/api/outdepotBill'
import { depotListSelectDataApi } from '@/api/depot'
import { materialsSchemeListSelectDataApi } from '@/api/materialsScheme'
import { loadDictDataApi } from '@/api/dict'
import { findAttachmentInfoByConditionApi, deleteFileApi, loadCurrentDateApi } from '@/api/common'
import { loadUserSelectDataByUserTypeApi } from '@/api/user'
import { initDepotApi } from '@/api/depot'

export default {
  components: { MaterialListDialog },
  mixins: [dialogDragMixin, setNumberMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: null
    }
  },
  data() {
    // 调入仓库
    const validateTransferDepotId = (rule, value, callback) => {
      if (value === this.dialogAddEditForm.depotId) {
        callback(new Error('调入仓库不能和调出仓库一样'))
      } else {
        callback()
      }
    }
    return {
      operateButtonDisable: false,
      loading: false,
      loadingText: '努力加载数据中，请耐心等待',

      dialogAddEditForm: {},
      dialogAddEditFormRules: {
        depotId: [{ required: true, message: '请选择出库仓库', trigger: 'change' }],
        outdepotDate: [{ required: true, message: '请选择出库时间', trigger: 'blur' }],
        outdepotType: [{ required: true, message: '请选择出库类型', trigger: 'change' }],
        schemeId: [{ required: true, message: '请选择物料方案', trigger: 'blur' }],
        operater: [{ required: true, message: '请输入经办人', trigger: 'blur' }],
        receiver: [{ required: true, message: '请输入物料使用人', trigger: 'blur' }],
        receiverId: [{ required: true, message: '请选择物料使用人', trigger: 'change' }],
        transferDepotId: [
          { required: true, message: '请选择调入仓库', trigger: 'change' },
          { validator: validateTransferDepotId, trigger: 'change' }
        ],
        remark: [{ max: 128, message: '最多输入128个字符', trigger: 'blur' }]
      },
      materialListData: [],
      depotOptions: [],
      typeOptions: [],
      schemeOptions: [],
      userOptions: [],
      dialogMaterialVisible: false,
      currentDate: '',
      isFixedAssetDepot: 2,
      picData: { directory: 'outdepotBill' },
      initFileList: [],
      dialogImageUrl: '',
      dialogImageVisible: false,
      picList: [], // 照片对象数组
      baseUrl: process.env.VUE_APP_BASE_API,
      picUploadAction: process.env.VUE_APP_BASE_API + '/web/common/uploadFile'
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        let _this = this
        _this.loading = true
        _this.loadingText = '努力加载数据中，请耐心等待'
        _this.operateButtonDisable = false

        _this.dialogAddEditForm = {
          provinceId: null,
          cityId: null,
          depotId: '',
          depotName: '',
          outdepotDate: '',
          outdepotType: '',
          schemeId: '',
          operater: '',
          receiverId: '',
          receiver: '',
          transferDepotId: '',
          transferDepotName: '',
          remark: ''
        }
        _this.depotOptions = []
        _this.typeOptions = []
        _this.schemeOptions = []
        _this.materialListData = []
        _this.userOptions = []
        _this.picList = []
        _this.initFileList = []
        _this.isFixedAssetDepot = 2

        _this.initCurrentDate()
        _this.initUserSelectData()
        _this.initOutdepotTypeSelectData()
        _this.initDepotSelectData()
        if (_this.eventType !== 'add') {
          _this.initData()
        }

        _this.$nextTick(() => {
          _this.$refs.dialogAddEditForm.clearValidate()
          _this.loading = false
        })
      }
    }
  },
  methods: {
    getToken,
    // 加载数据
    initData() {
      let _this = this
      initOutdepotBillApi({ id: _this.dataId }).then(res => {
        const { data } = res
        for (let key in _this.dialogAddEditForm) {
          if (key.endsWith('Date')) _this.dialogAddEditForm[key] = data[key + 'Str']
          else if (key.endsWith('Id') || key === 'outdepotType') _this.dialogAddEditForm[key] = Number(data[key])
          else _this.dialogAddEditForm[key] = data[key]
        }
        _this.dialogAddEditForm.id = data.id
        _this.loadBillFileData()
        _this.initDetailData()
        initDepotApi({ id: data.depotId }).then(res => {
          let depot = res.data
          _this.dialogAddEditForm.provinceId = depot.provinceId
          _this.dialogAddEditForm.cityId = depot.cityId
          _this.initSchemeSelectData(depot.provinceId, depot.cityId, _this.dialogAddEditForm.outdepotType)
        })
      })
    },
    // 初始化系统时间
    initCurrentDate() {
      loadCurrentDateApi().then(res => {
        const { data } = res
        this.currentDate = data
        this.currentDate = this.currentDate.replace('-', '').replace('-', '')
      })
    },
    // 加载出库库明细物料数据
    initDetailData() {
      initOutdepotBillDetailApi({ outdepotId: this.dataId }).then(res => {
        const { data } = res
        this.materialListData = data || []
        this.loading = false
      })
    },
    // 加载出库单附件数据
    loadBillFileData() {
      findAttachmentInfoByConditionApi({ sourceType: 4, sourceId: this.dataId }).then(res1 => {
        if (res1.data && res1.data.length > 0) {
          res1.data.forEach(item => {
            let obj = {}
            obj.name = item.attachmentName
            obj.url = this.baseUrl + item.attachmentUrl
            obj.attachmentName = item.attachmentName
            obj.attachmentUrl = item.attachmentUrl
            this.picList.push(obj)
            this.initFileList.push(obj)
          })
        }
      })
    },
    // 初始出库类型下拉数据
    initOutdepotTypeSelectData() {
      loadDictDataApi({ type: 5 }).then(res => {
        let resultData = res.data
        resultData.forEach(item => {
          if (item.optionValue === 3) { //品牌推广
            this.typeOptions.push({ label: item.optionLable + '(推广活动)', data: Number(item.optionValue) })
          } else if (item.optionValue === 4) { //品鉴活动
            this.typeOptions.push({ label: item.optionLable + '(一桌式品鉴,场所品吸,互助小组)', data: Number(item.optionValue) })
          } else {
            this.typeOptions.push({ label: item.optionLable, data: Number(item.optionValue) })
          }
        })
      })
    },
    // 选择出库类型回调
    changeTypeFun(val) {
      let _this = this
      _this.schemeOptions = []
      _this.materialListData = []
      _this.dialogAddEditForm.receiver = ''
      _this.dialogAddEditForm.receiverId = ''
      _this.dialogAddEditForm.schemeId = ''
      if (val) {
        _this.initSchemeSelectData(_this.dialogAddEditForm.provinceId, _this.dialogAddEditForm.cityId, val)
      }
    },
    // 初始出库仓库下拉数据
    initDepotSelectData() {
      depotListSelectDataApi({ status: 1 }).then(response => {
        let _this = this
        const { data } = response
        data.forEach(item => {
          _this.depotOptions.push({ label: item.name, data: item.id, provinceId: item.provinceId, cityId: item.cityId, isFixedAsset: item.isFixedAsset })
        })
        if (_this.eventType === 'add') _this.loading = false
      })
    },
    // 选择出库库房回调
    depotChangeFun(val) {
      let _this = this
      _this.schemeOptions = []
      _this.materialListData = []
      let selectItem = {}
      selectItem = _this.depotOptions.find(item => {
        return item.data === val
      })
      _this.dialogAddEditForm.depotName = selectItem ? selectItem.label : ''
      _this.isFixedAssetDepot = selectItem ? selectItem.isFixedAsset : 2
      if ((_this.dialogAddEditForm.outdepotType === 21 && _this.isFixedAssetDepot === 2) || (_this.dialogAddEditForm.outdepotType !== 21 && _this.isFixedAssetDepot === 1)) {
        _this.dialogAddEditForm.outdepotType = ''
      }
      _this.schemeOptions = []
      _this.dialogAddEditForm.schemeId = ''
      if (val) {
        _this.dialogAddEditForm.provinceId = selectItem.provinceId
        _this.dialogAddEditForm.cityId = selectItem.cityId
        _this.initSchemeSelectData(selectItem.provinceId, selectItem.cityId, _this.dialogAddEditForm.outdepotType)
      }
    },
    // 调入仓库选择回调
    transferDepotChangeFun(val) {
      let _this = this
      let selectItem = {}
      selectItem = _this.depotOptions.find(item => {
        return item.data === val
      })
      _this.dialogAddEditForm.transferDepotName = selectItem ? selectItem.label : ''
    },
    // 初始方案编号下拉数据
    initSchemeSelectData(provinceId, cityId, outType) {
      let _this = this
      if (provinceId === null || provinceId === '' || cityId === null || cityId === '' || outType === null || outType === '') {
        return
      }
      _this.loading = true
      // 非四川省区 区域区分条件只细化到省区
      if (provinceId !== 7) {
        cityId = ''
      }
      let params = { provinceId: provinceId, cityId: cityId, status: 2, schemeStatus: 1 }
      if (outType === 2 || outType === 5 || outType === 6 || outType === 7) {
        params = { provinceId: provinceId, cityId: cityId, status: 2, isHasInventoryLeft: 1 }
      }
      materialsSchemeListSelectDataApi(params).then(response => {
        const { data } = response
        data.forEach(item => {
          _this.schemeOptions.push({ label: item.name, data: item.id, name: item.name, schemeNo: item.projectNo, schemeType: item.schemeTypeStr })
        })
        _this.loading = false
      })
    },
    // 选择方案回调
    changeSchemeFun() {
      this.materialListData = []
    },
    // 获取物料使用人下拉框数据
    initUserSelectData() {
      loadUserSelectDataByUserTypeApi().then(response => {
        response.data.forEach(item => {
          this.userOptions.push({ label: item.name, data: item.id })
        })
      })
    },
    // 物料使用人选择回调
    userChangeFun(val) {
      let selectItem = {}
      selectItem = this.userOptions.find(item => {
        return item.data === val
      })
      this.dialogAddEditForm.receiver = selectItem ? selectItem.label : ''
    },
    // 添加物料
    handleAdd() {
      if (!this.dialogAddEditForm.depotId) {
        this.$message({ message: '请选择出库仓库', type: 'warning' })
        return
      } else {
        this.dialogMaterialVisible = !this.dialogMaterialVisible
      }
    },
    // 选择物料
    selectedMaterialsFun(selectData) {
      selectData.forEach(item => {
        let hasItem = false
        this.materialListData.forEach(mItem => {
          if (mItem.materialsId === item.materialsId && mItem.schemeId === item.schemeId) {
            hasItem = true
          }
        })
        if (!hasItem) {
          item.maxAmount = item.amount
          item.amount = 0
          item.total = Number(item.amount) * Number(item.price)
          this.materialListData.push(item)
        }
      })
    },
    // 删除物料
    handleDeleteItem(index) {
      this.materialListData.splice(index, 1)
    },
    // 计算合计
    computedMathRow(val, obj, name) {
      if (name === 'amount') {
        if (val > Number(obj.maxAmount)) {
          val = Number(obj.maxAmount)
          obj[name] = val
        }
      }
      this.limitPositiveNumber(val, obj, name)
      this.setNumberZero(obj, name)
      obj['total'] = Number(obj['price']) * Number(obj['amount'])
    },
    // 图片上传前
    beforeAvatarUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isLt5M) {
        this.$message.error('上传图片大小不能超过5MB!')
        return false
      }
      this.isUploading = true
    },
    // 预览
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogImageVisible = true
    },
    // 上传成功
    handleSuccess(res, file, fileList, dataObj) {
      if (res.mark === '200') {
        let fileObj = {}
        fileObj.attachmentName = res.myFileName
        fileObj.attachmentUrl = res.fileName
        fileObj.url = this.baseUrl + res.fileName
        dataObj.push(fileObj)
        this.isUploading = false
      } else {
        this.$message.error(res.message)
      }
    },
    // 删除
    handlePictureCardRemove(file, fileList, dataObj) {
      let fileUrl = ''
      if (file.response) {
        let resData = file.response
        let delIndex = dataObj.findIndex(item => {
          return item.attachmentUrl === resData.fileName
        })
        fileUrl = resData.fileName
        dataObj.splice(delIndex, 1)
      } else {
        let delIndex = dataObj.findIndex(item => {
          if (item.url === file.url) {
            fileUrl = item.attachmentUrl
            return item.url === file.url
          }
        })
        dataObj.splice(delIndex, 1)
      }
      if (fileUrl !== '') {
        deleteFileApi({ filePath: fileUrl }).then(res => {
          if (res.mark === '200') {
            this.$message({ message: res.message, type: 'success' })
          }
        })
      }
    },
    // 加载数据
    reloadData() {
      this.$emit('reloadData')
    },
    modalClose() {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
      this.$refs.dialogAddEditForm.clearValidate()
    },
    // 新增|修改保存
    handleSave() {
      let _this = this
      _this.$refs.dialogAddEditForm.validate(valid => {
        if (valid) {
          if (_this.materialListData.length === 0) {
            _this.$message({ message: '无出库物料明细，不能保存', type: 'warning' })
            return
          } else {
            let isZero = false
            _this.materialListData.forEach(item => {
              if (Number(item.amount) === 0) {
                isZero = true
              }
            })
            if (isZero) {
              _this.$message({ message: '出库物料数量不能为0，不能保存', type: 'warning' })
              return false
            }
          }
          if (Number(_this.currentDate) < Number(_this.dialogAddEditForm.outdepotDate.replace('-', '').replace('-', ''))) {
            _this.$message({ message: '出库日期不能大于当前日期，不能保存', type: 'warning' })
            return false
          }

          _this.$confirm(
            (_this.eventType === 'add' ? '是否确定新增' : '是否确定修改') + '出库单', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }
          ).then(async () => {
            _this.operateButtonDisable = true
            _this.loading = true
            _this.loadingText = '正在处理数据中，请耐心等待'

            _this.dialogAddEditForm.detailInfo = JSON.stringify(_this.materialListData)
            let picUrls = []
            let picNames = []
            _this.picList.forEach(item => {
              picUrls.push(item.attachmentUrl)
              picNames.push(item.attachmentName)
            })
            _this.dialogAddEditForm.picUrls = JSON.stringify(picUrls)
            _this.dialogAddEditForm.picNames = JSON.stringify(picNames)

            saveOrUpdateOutdepotBillApi(_this.dialogAddEditForm).then(res => {
              if (res.mark === '200') {
                _this.$message({ message: res.message, type: 'success' })
                _this.reloadData()
                _this.modalClose()
              }
            }).catch(() => {
              _this.loading = false
              _this.operateButtonDisable = false
            })
          }).catch(() => { })
        }
      })
    }
  }
}
</script>
<style lang="scss"  scoped>
.el-table--border {
  border-left: 1px solid #dfe6ec;
  margin-top: 5px;
}
::v-deep .el-table {
  th {
    color: #ffffff;
    .cell {
      line-height: 17px;
    }
    .caret-wrapper {
      height: 18px;
    }
    .sort-caret {
      border-width: 4px;
      &.ascending {
        top: 0;
      }
      &.descending {
        bottom: 0;
      }
    }
  }
  .ascending .sort-caret.ascending {
    border-bottom-color: #ffffff;
  }
  .descending .sort-caret.descending {
    border-top-color: #ffffff !important;
  }
}
::v-deep .el-table--mini th,
::v-deep .el-table--mini td {
  padding: 4px;
  font-size: 12px;
}
::v-deep .el-table--mini td {
  padding: 4px;
}
.pic-container {
  position: relative;
  .pic-name {
    display: inline-block;
    padding-top: 7px;
    margin-bottom: 10px;
  }
  .upload-button {
    position: absolute;
    top: 0;
    right: 0px;
  }
  ::v-deep .el-upload--picture-card i {
    font-size: 14px !important;
    color: #fff !important;
  }
  ::v-deep .el-upload--picture-card {
    border: none;
    height: 0px;
    overflow: hidden;
  }
}
::v-deep .el-upload-list--picture-card {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;
  .el-upload-list__item {
    display: flex;
    flex: 0 0 218px;
    margin-right: 8px;
    width: 218px;
    height: 218px;
    align-items: center;
    border-radius: 0;
  }
  .el-upload-list__item-thumbnail {
    height: auto;
    align-items: center;
  }
}
</style>
